var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"PersonalizedCustomization"}},[_c('view1'),_c('view2'),_c('view3')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }